/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import {
    HOME_PAGE_UNLOADED,
} from '../../constants/actionTypes';

var currdeg, myTimeout, slideAngle, slideTranslateZ, count, translateZInit, windowWidth, hoverZ;
var animating, slideWidth, $wrapper, slideIndex, slideLen, speed, originalSlideLen;
var thisSlide, location, pageName;
var addX = 0;
var addY = 0;
var mouseX = 0;
var mouseY = 0;
var startX = 0;
var startY = 0;
var oldX = 0;
var oldY = 0;
var mouseWheelType;
var MOUSE_WHEEL_TYPES = {
    HORIZONTAL: 0,
    VERTICAL: 1,
    ROTATE: 2,
    NONE: -1
};
var looper;
var STATE = {
    NONE: -1,
    ROTATE: 0,
    ZOOM: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_ZOOM_PAN: 4
};
var _state;
const mapStateToProps = state => ({
    ...state.home,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onUnload: () =>
        dispatch({ type: HOME_PAGE_UNLOADED })
});

class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.looper = this.looper.bind(this);
        this.mousewheel = this.mousewheel.bind(this);
        this.mousemove = this.mousemove.bind(this);
        this.mouseup = this.mouseup.bind(this);
        this.mousedown = this.mousedown.bind(this);
        this.touchstart = this.touchstart.bind(this);
        this.touchmove = this.touchmove.bind(this);
        this.touchend = this.touchend.bind(this);
        this.state = {
            value: ''
        }
    }

    TrackingPointer(domElement, wheelType) {

        var _this = this;
        looper = looper;
        mouseWheelType = (wheelType !== undefined) ? wheelType : 0;

        _state = STATE.NONE;
        this.domElement = (domElement !== undefined) ? domElement : document;

        var changeEvent = {
            type: 'change'
        };
        var startEvent = {
            type: 'start'
        };
        var endEvent = {
            type: 'end'
        };
        window.addEventListener('wheel', this.mousewheel, false);
        window.addEventListener('mousedown', this.mousedown, false);
        window.addEventListener('touchstart', this.touchstart, false);
        window.addEventListener('touchend', this.touchend, false);
        window.addEventListener('touchmove', this.touchmove, false);

    }
    componentWillMount() {

    }

    mousemove(event) {
        event.preventDefault();
        event.stopPropagation();
        mouseX = event.pageX;
        mouseY = event.pageY;
        addX += (mouseX - oldX);
        addY += (mouseY - oldY);
        if (oldX == 0) {
            addX = 0;
        }
        if (oldY == 0) {
            addY = 0;
        }
        oldX = mouseX;
        oldY = mouseY;
        this.looper();
    }

    mouseup(event) {
        if (Math.abs(addX) > 10) {
            addX = addX * 150;
            this.looper()
        }
        addX = 0;
        oldX = 0;
        addY = 0;
        oldY = 0;
        document.removeEventListener('mousemove', this.mousemove);
        document.removeEventListener('mouseup', this.mouseup);
    }

    mousedown(event) {
        event.preventDefault();
        event.stopPropagation();
        oldX = 0;
        oldY = 0;
        startX = event.pageX;
        startY = event.pageY;
        document.addEventListener('mousemove', this.mousemove, false);
        document.addEventListener('mouseup', this.mouseup, false);
    }

    touchstart(event) {
        oldX = 0;
        oldY = 0;
        startX = event.touches[0].pageX;
        startY = event.touches[0].pageY;
    }

    touchmove(event) {

        switch (event.touches.length) {

            case 1:
                event.preventDefault();
                event.stopPropagation();
                mouseX = event.touches[0].pageX;
                mouseY = event.touches[0].pageY;

                addX += (mouseX - oldX);
                addY += (mouseY - oldY);
                if (oldX == 0) {
                    addX = 0;
                }
                if (oldY == 0) {
                    addY = 0;
                }
                oldX = mouseX;
                oldY = mouseY;
                this.looper()
                break;

            default:

                break;

        }
    }

    mousewheel(event) {
        switch (event.deltaMode) {
            case 2:
                // Zoom in pages
                break;

            case 1:
                event.preventDefault();
                event.stopPropagation();
                // Zoom in lines
                if (MOUSE_WHEEL_TYPES.HORIZONTAL == mouseWheelType) {
                    mouseX = event.deltaY * 2.70;
                    addX += mouseX;
                    this.looper();
                } else if (MOUSE_WHEEL_TYPES.VERTICAL == mouseWheelType) {
                    mouseY = event.deltaY * 2.70;
                    addY += mouseY;
                    this.looper();
                }
                break;

            default:
                event.preventDefault();
                event.stopPropagation();
                // undefined, 0, assume pixels
                if (MOUSE_WHEEL_TYPES.HORIZONTAL == mouseWheelType) {
                    mouseX = event.deltaY * 2.70;
                    addX += mouseX;
                    this.looper();
                } else if (MOUSE_WHEEL_TYPES.VERTICAL == mouseWheelType) {
                    mouseY = event.deltaY * 2.70;
                    addY += mouseY;
                    this.looper();
                }
                break;

        }


    }

    touchend(event) {
        if (Math.abs(addX) > 10) {
            addX = addX * 150;
            this.looper();
        }
        addX = 0;
        addY = 0;
        oldX = 0;
        oldY = 0;
    }

    looper() {
        this.slideNormal();
        if (addX !== 0 && (Math.abs(addX) * 2 / windowWidth) > 1) {
            if (addX < 0) {
                this.slide(addX, "left");

            } else {
                this.slide(addX, "right");
            }
            addX = 0;
            oldX = 0;
        } else if (addY !== 0 && Math.abs(addY) / 6 > 1) {
            addY = 0;

        }
        this.slideHover();
    }

    slideNormal() {
        $('.slider').each(function (index) {
            var angleNew = $(this)[0].style.transform.split(' ')[0].split('(')[1].split('deg')[0];
            var translateZNew = $(this)[0].style.transform.split(' ')[1].split('(')[1].split(')')[0];
            if (translateZNew == hoverZ) {
                const tZUnit = window.innerWidth < 1279 ? "px" : "vw";
                $(this).css({
                    "transition": "0.2s",
                    "transform": "rotateY(" + parseFloat(angleNew)  + "deg) translateZ(-" + translateZInit + ""+tZUnit+")"
                });
            }
        });
    }
    slideHover() {

        if (myTimeout !== undefined) {
            clearTimeout(myTimeout);
        }

        myTimeout = setTimeout(function () {
            var array = [], carouselAngle;
            $('.slider').each(function (index) {
                slideAngle = $(this)[0].style.transform.split(' ')[0].split('(')[1].split('deg')[0];
                slideTranslateZ = $(this)[0].style.transform.split(' ')[1].split('(')[1].split(')')[0];
                if ($("#carousel")[0].style.transform !== '') {
                    carouselAngle = parseFloat($("#carousel")[0].style.transform.split(' ')[0].split('(')[1].split('deg')[0]);
                } else {
                    carouselAngle = 0;
                }
                var corectedAngle = ((carouselAngle <= 0) ? -parseFloat(carouselAngle % 360) : 360 - parseFloat(carouselAngle % 360));
                corectedAngle = ((corectedAngle % 360) == 0) ? 0 : corectedAngle;
                if (corectedAngle.toFixed(2) == parseFloat(slideAngle).toFixed(2)) {
                    $("#slide" + index).css({
                        "transition": "0.2s",
                        "transform": "rotateY(" + parseFloat(slideAngle) + "deg) translateZ(" + hoverZ + ")"
                    });
                }
            });
        }, 1000);
    }
    slide(val, direction) {
        var carousel = $("#carousel");
        if (direction == "left") {
            currdeg += parseFloat(360 / count);
        }
        else {
            currdeg -= parseFloat(360 / count);
        }
        this.slideNormal();
        carousel.css({
            "-webkit-transform": "rotateY(" + currdeg + "deg)",
            "-moz-transform": "rotateY(" + currdeg + "deg)",
            "-o-transform": "rotateY(" + currdeg + "deg)",
            "transform": "rotateY(" + currdeg + "deg)"
        });
        this.slideHover();
        this.sliderMove(direction);
    }

    build(direction) {
        if (pageName == "team") {
            var i, $clone;
            if (direction == 'right') {
                for (i = 0; i < slideLen; i++) {
                    $clone = $('#teamNavigation > .innerwrapper .inner-slide').eq(i).clone();
                    $wrapper.find('.innerwrapper').append($clone);
                }
                $wrapper.animate({
                    scrollLeft: '-=' + slideWidth * (slideLen / 2) + 'px'
                }, 0);
            } else if (direction == 'left') {
                var cloneArray = [];
                for (i = 0; i < slideLen; i++) {
                    $clone = $('#teamNavigation > .innerwrapper .inner-slide').eq(i).clone();
                    cloneArray.push($clone);
                }
                $wrapper.find('.innerwrapper').prepend(cloneArray);
                $wrapper.animate({
                    scrollLeft: '+=' + slideWidth * (slideLen / 2) + 'px'
                }, 0);
            } else {
            }
            $('#teamNavigation > .innerwrapper .inner-slide').prop('onclick', null).off('click');
            $('#teamNavigation > .innerwrapper .inner-slide').on('click', function () {
                thisSlide.slideNav($(this))
            });
        } else {
            var i, $clone;
            if (direction == 'right') {
                for (i = 0; i < slideLen; i++) {
                    $clone = $('#productNavigation > .innerwrapper .inner-slide').eq(i).clone();
                    $wrapper.find('.innerwrapper').append($clone);
                }
                $wrapper.animate({
                    scrollLeft: '-=' + slideWidth * (slideLen / 2) + 'px'
                }, 0);
            } else if (direction == 'left') {
                var cloneArray = [];
                for (i = 0; i < slideLen; i++) {
                    $clone = $('#productNavigation > .innerwrapper .inner-slide').eq(i).clone();
                    cloneArray.push($clone);
                }
                $wrapper.find('.innerwrapper').prepend(cloneArray);
                $wrapper.animate({
                    scrollLeft: '+=' + slideWidth * (slideLen / 2) + 'px'
                }, 0);
            } else {
            }
            $('#productNavigation > .innerwrapper .inner-slide').prop('onclick', null).off('click');
            $('#productNavigation > .innerwrapper .inner-slide').on('click', function () {
                thisSlide.slideNav($(this))
            });
        }
    }

    sliderMove(direction) {

        if (pageName == "team") {
            if (!animating) {
                animating = true;
                var activeSlide = $("#teamNavigation > .innerwrapper .inner-slide.active");
                var prevSlide = $("#teamNavigation > .innerwrapper .inner-slide.active").prev();
                var nextSlide = $("#teamNavigation > .innerwrapper .inner-slide.active").next();
                activeSlide.removeClass('active');
                if (direction == 'right') {
                    prevSlide.addClass('active');
                    slideIndex--;
                    var tempSlide = $('#teamNavigation > .innerwrapper .inner-slide').eq(slideLen - 1).clone();
                    $('#teamNavigation > .innerwrapper .inner-slide').eq(slideLen - 1).remove();
                    $wrapper.find('.innerwrapper').prepend(tempSlide);
                    tempSlide.on('click', function () {
                        thisSlide.slideNav($(this))
                    });
                } else {
                    nextSlide.addClass('active');
                    slideIndex++;
                    var tempSlide = $('#teamNavigation > .innerwrapper .inner-slide').eq(0).clone();
                    $('#teamNavigation > .innerwrapper .inner-slide').eq(0).remove();
                    $wrapper.find('.innerwrapper').append(tempSlide);
                    tempSlide.on('click', function () {
                        thisSlide.slideNav($(this))
                    });
                }
            }
            animating = false;
        } else {
            if (!animating) {
                animating = true;
                var activeSlide = $("#productNavigation > .innerwrapper .inner-slide.active");
                var prevSlide = $("#productNavigation > .innerwrapper .inner-slide.active").prev();
                var nextSlide = $("#productNavigation > .innerwrapper .inner-slide.active").next();
                activeSlide.removeClass('active');
                if (direction == 'right') {
                    prevSlide.addClass('active');
                    slideIndex--;
                    var tempSlide = $('#productNavigation > .innerwrapper .inner-slide').eq(slideLen - 1).clone();
                    $('#productNavigation > .innerwrapper .inner-slide').eq(slideLen - 1).remove();
                    $wrapper.find('.innerwrapper').prepend(tempSlide);
                    tempSlide.on('click', function () {
                        thisSlide.slideNav($(this))
                    });
                } else {
                    nextSlide.addClass('active');
                    slideIndex++;
                    var tempSlide = $('#productNavigation > .innerwrapper .inner-slide').eq(0).clone();
                    $('#productNavigation > .innerwrapper .inner-slide').eq(0).remove();
                    $wrapper.find('.innerwrapper').append(tempSlide);
                    tempSlide.on('click', function () {
                        thisSlide.slideNav($(this))
                    });
                }
            }
            animating = false;
        }
    }
    slideNav(dir) {
        if (pageName == "team") {
            var activeValue = $("#teamNavigation > .innerwrapper .inner-slide.active").index();
            var prevValue = $("#teamNavigation > .innerwrapper .inner-slide.active").prev().index();
            var clickedValue = parseInt(dir.index());
            var totalMove = clickedValue - activeValue;
            if (prevValue != undefined) {
                dir = (clickedValue <= parseInt(prevValue)) ? 'left' : 'right';
                dir = (dir == 'left') ? 'right' : 'left';
                for (var j = 0; j < Math.abs(totalMove); j++) {
                    this.slide('', dir);
                }
            }
        }
        else {
            var activeValue = $("#productNavigation > .innerwrapper .inner-slide.active").index();
            var prevValue = $("#productNavigation > .innerwrapper .inner-slide.active").prev().index();
            var clickedValue = parseInt(dir.index());
            var totalMove = clickedValue - activeValue;
            if (prevValue != undefined) {
                dir = (clickedValue <= parseInt(prevValue)) ? 'left' : 'right';
                dir = (dir == 'left') ? 'right' : 'left';
                for (var j = 0; j < Math.abs(totalMove); j++) {
                    this.slide('', dir);
                }
            }
        }
    }
    componentDidMount() {
        thisSlide = this;
        pageName = this.props.pageName;
        currdeg = parseFloat(0.0);
        this.TrackingPointer(document.getElementById('carouselContainer'), this.looper());
        if (pageName == "team") {
            window.generateTeamCarousel('carousel', 13);
            count = 13;
            translateZInit = window.innerWidth < 1279 ? 3250 : 169.2708;
            hoverZ = "0px";
            $('#productNavigation').hide();
        }
        else {
            window.generateProductCarousel('carousel', 3);
            count = 3;
            translateZInit = window.innerWidth < 1279 ? 500 : 26.0417;
            hoverZ = "0px";
            $('#teamNavigation').hide();
        }


        var CONTAINER_ORIGINAL_WIDTH = $('#carouselContainer').css('width');
        var CONTAINER_ORIGINAL_HEIGHT = $('#carouselContainer').css('height');

        var CONTAINER1_ORIGINAL_WIDTH = $(window).width();
        var CONTAINER1_ORIGINAL_HEIGHT = $(window).height();
        windowWidth = CONTAINER1_ORIGINAL_WIDTH;

        var mobileHightAdj = 50;
        var mobileWidthAdj = 50;

        var resizePadding = 1;
        var mousehover = 0;

        var isPortrait = false;
        var isMobile = false;

        if (window.matchMedia("(orientation: portrait)").matches) {
            // you're in PORTRAIT mode
            isPortrait = true;
        }

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
            .test(navigator.userAgent)) {
            mousehover = 1;
            isMobile = true;
        } else {
            if (isPortrait == true) {
                $("#portrait-blocker").hide();
            }
        }
        screenresize(true);

        $(window).resize(function () {
            screenresize(true);
        });

        function screenresize(isonload) {
            slideWidth = $('.inner-slide').width();
        }

        animating = false;
        (pageName == "team") ? slideLen = $('#teamNavigation > .innerwrapper .inner-slide').length : slideLen = $('#productNavigation > .innerwrapper .inner-slide').length;
        (pageName == "team") ? $wrapper = $('#teamNavigation') : $wrapper = $('#productNavigation');
        (pageName == "team") ? slideIndex = 7 : slideIndex = 1;
        originalSlideLen = slideLen;
        speed = 100;
        this.build('');
        thisSlide = this;
    }
    componentWillUnmount() {
        window.removeEventListener('wheel', this.mousewheel);
        window.removeEventListener('mousedown', this.mousedown);
        window.removeEventListener('touchstart', this.touchstart);
        window.removeEventListener('touchend', this.touchend);
        window.removeEventListener('touchmove', this.touchmove);
        this.props.onUnload();
    }
    render() {
        return (
            <div id="carouselContainer" className="carouselContainer">
                <div id="carousel">
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Slider);




// WEBPACK FOOTER //
// src/components/Common/Slider.js